export default __webpack_public_path__ + "cd8a6861e5aecda9a8a51a1aad503b36.jpg";